import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@unicup-ticketing/auth';

export const LoginRedirect: CanActivateFn = (route, state, service = inject(AuthService)) => {
  return service.handleLoginRedirect();
};
